/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsUserAddress,
    MelcoModelsUserAddressFromJSON,
    MelcoModelsUserAddressFromJSONTyped,
    MelcoModelsUserAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsEditSubUser
 */
export interface MelcoModelsEditSubUser {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    last_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    company_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    gender_code?: string | null;
    /**
     * 
     * @type {MelcoModelsUserAddress}
     * @memberof MelcoModelsEditSubUser
     */
    address?: MelcoModelsUserAddress;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    api_key?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsEditSubUser
     */
    service_terms?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEditSubUser
     */
    parent_user_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsEditSubUser
     */
    is_locked_out?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsEditSubUser
     */
    is_disabled?: boolean;
}

export function MelcoModelsEditSubUserFromJSON(json: any): MelcoModelsEditSubUser {
    return MelcoModelsEditSubUserFromJSONTyped(json, false);
}

export function MelcoModelsEditSubUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsEditSubUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'company_name': !exists(json, 'company_name') ? undefined : json['company_name'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'gender_code': !exists(json, 'gender_code') ? undefined : json['gender_code'],
        'address': !exists(json, 'address') ? undefined : MelcoModelsUserAddressFromJSON(json['address']),
        'api_key': !exists(json, 'api_key') ? undefined : json['api_key'],
        'service_terms': !exists(json, 'service_terms') ? undefined : json['service_terms'],
        'parent_user_id': !exists(json, 'parent_user_id') ? undefined : json['parent_user_id'],
        'is_locked_out': !exists(json, 'is_locked_out') ? undefined : json['is_locked_out'],
        'is_disabled': !exists(json, 'is_disabled') ? undefined : json['is_disabled'],
    };
}

export function MelcoModelsEditSubUserToJSON(value?: MelcoModelsEditSubUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'company_name': value.company_name,
        'website': value.website,
        'phone': value.phone,
        'gender_code': value.gender_code,
        'address': MelcoModelsUserAddressToJSON(value.address),
        'api_key': value.api_key,
        'service_terms': value.service_terms,
        'parent_user_id': value.parent_user_id,
        'is_locked_out': value.is_locked_out,
        'is_disabled': value.is_disabled,
    };
}


